import { render, staticRenderFns } from "./AppImputable.vue?vue&type=template&id=0fc73979&scoped=true&"
import script from "./AppImputable.vue?vue&type=script&lang=js&"
export * from "./AppImputable.vue?vue&type=script&lang=js&"
import style0 from "./AppImputable.vue?vue&type=style&index=0&id=0fc73979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc73979",
  null
  
)

export default component.exports